
import Vue from "vue";
import { OrderResource } from "../../../models/api/orders/get";
import { OrderModule } from "@/store/modules";
import { Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import * as modals from "@/lib/modals";

const orderModule = getModule(OrderModule);

@Component({
  name: modals.manualConsolidationWizardModal
})
export default class ManualConsolidationWizardModal extends Vue {
  currentStep: number = 1;
  visible: boolean = false;
  orderNumber: number = null;
  canGoNext: boolean = false;
  errorMessage: string = null;
  orderToConsolidate: OrderResource = null;
  loading: boolean = false;
  $refs: {
    orderNumber: any;
  };

  get currentOrder() {
    return orderModule.currentOrder;
  }

  loadOrderToConsolidate() {
    return new Promise(resolve => {
      this.loading = true;
      orderModule
        .fetchOrder(this.orderNumber)
        .then((response: any) => {
          this.orderToConsolidate = response.data;
          this.loading = false;
          this.errorMessage = null;
          resolve(true);
        })
        .catch(ex => {
          this.errorMessage = `Order #${this.orderNumber} not found`;
          this.loading = false;
          resolve(false);
        });
    });
  }

  consolidateOrder() {
    return new Promise(resolve => {
      this.loading = true;
      orderModule
        .addOrderToShipsWithOrder({
          existingShipsWithOrdersPromptResult: true,
          childOrderNumber: this.orderToConsolidate.headerNumber,
          shipWithOrderHeaderNumber: this.currentOrder.headerNumber
        })
        .then(() => {
          this.loading = false;
          this.errorMessage = null;
          resolve(true);
        })
        .catch(ex => {
          this.errorMessage = "Failed to consolidate order. " + ex.response.data.message;
          this.loading = false;
          resolve(true);
        });
    });
  }
  show() {
    this.visible = true;
  }

  hidden() {
    this.orderNumber = null;
    this.$emit("hidden");
  }

  hide() {
    this.visible = false;
  }

  navigate(props) {
    if (props.isLastStep) {
      return;
    }

    props.navigateToTab(props.index);
  }

  get hasErrorMessage() {
    return this.errorMessage !== null;
  }
}
